import {Formik} from "formik";
import {useMemo, useState} from "react";
import FormKeHoach from "./components/FormKeHoach";
import * as Yup from "yup";
import {YeuCauHoTroProvider} from "../../contexts/yeuCauHoTro";

interface Props {
  warehouseId?: number;
  className?: any;
}

export const YeuCauHoTro = (props: Props) => {
  const {warehouseId, className} = props;
  const [dsYeuCau, setDsYeuCau] = useState([]);
  const [detailPhieuYeuCau, setDetailPhieuYeuCau] = useState({});

  let validationSchema = Yup.object({});
  const handleFormSubmit = (values: any) => {
  }

  const contextValue = useMemo(() => ({
    dsYeuCau: dsYeuCau,
    setDsYeuCau: setDsYeuCau,
    detailPhieuYeuCau,
    setDetailPhieuYeuCau,
  }), [dsYeuCau, detailPhieuYeuCau]);
  return (
    <Formik<any>
      initialValues={{}}
      validationSchema={validationSchema}
      onSubmit={handleFormSubmit}
    >
      <YeuCauHoTroProvider value={contextValue}>
        <div className="bg-white">
          <div className="flex-1 flex flex-column">
            <div className="py-1">
              <FormKeHoach
                className={className}
                warehouseId={warehouseId}
              />
            </div>
          </div>
        </div>

      </YeuCauHoTroProvider>
    </Formik>

  )
}

export default YeuCauHoTro;
